import styles from "./PhotographerHeader.module.css";
import Image from "next/image";

export default function PhotographerHeader({photographer}){
    <section className={styles.photographerHeader}>
        <div className={styles.photographerPresentation}>
            <h1 className={styles.photographerName}>{photographer.name}</h1>
            <h2 className={styles.photographerLocation}>{photographer.city}, {photographer.country}</h2>
            <p className={styles.photographerTagline}>{photographer.tagline}</p>
        </div>
        <div className={styles.contactButtonWrapper}>
            <button className={styles.contactButton}>Contactez-moi</button>
        </div>
        <div className={styles.portraitWrapper}>
            <Image 
                src={"/assets/" + photographer.portrait}
                width={200}
                height={200}
                className={styles.photographerPortrait}
                alt={"Photo de " + photographer.name}
            />
        </div>
    </section>
}